var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cb0001;}.cls-2{fill:#f6e9e8;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,7.25a3.93,3.93,0,0,1,.58.88,8.4,8.4,0,0,1-1.21-.35c-.13,0-.17.08-.23.15l-.71,1-.05,0c0-.37,0-.74,0-1.11s-.08-.31-.29-.37-.7-.22-1.14-.36c.44-.14.8-.27,1.16-.37.2-.06.29-.14.27-.35a5.56,5.56,0,0,1,.06-1.14c.22.3.45.59.67.9a.3.3,0,0,0,.42.14c.35-.13.72-.23,1.13-.36a6.39,6.39,0,0,1-.67,1A.32.32,0,0,0,17,7.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,9.32a3.86,3.86,0,0,1-3.11,1.75A4,4,0,0,1,7.74,10a3.92,3.92,0,0,1-.42-5.52A4.19,4.19,0,0,1,14,4.64a3.45,3.45,0,0,0-4.75.15,3.17,3.17,0,0,0,.14,4.58A3.39,3.39,0,0,0,14,9.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.1ef2afab7d54509c3ea94b9716cb00d3.svg";
export { ForwardRef as ReactComponent };